const state = {
  robotArmInfo: {
    armParam: ''
  }
}
const getters = {
  robotArmInfo: state => state.robotArmInfo
}
const mutations = {
  SET_RobotArmInfo (state, payload) {
    state.robotArmInfo = { ...state.robotArmInfo, ...payload }
  }
}

const actions = {
  updateRobotArmInfo ({ commit }, payload) {
    commit('SET_RobotArmInfo', payload)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
